angular.module('graph').controller('ph-like', [
    '$scope',
    'ph-core',
    function ($scope, $core) {
        $scope.like = function ($space, $entry) {
            $core.post('/xhr/' + $space + '/' + $entry.id + '/likes')
                .then(function ($response) {
                    if ($response.data.state === 0) {
                        ++$entry.likes;
                        $entry.liked = true;
                    }
                });
        };

        $scope.unlike = function ($space, $entry) {
            $core.delete('/xhr/' + $space + '/' + $entry.id + '/likes')
                .then(function ($response) {
                    if ($response.data.state === 0) {
                        --$entry.likes;
                        $entry.liked = false;
                    }
                });
        };

        $scope.comment = function ($space, $entry) {
            $core.post('/xhr/' + $space + '/' + $entry.id + '/comments')
                .then(function ($response) {
                    if ($response.data.state === 0) {
                        --$entry.likes;
                        $entry.liked = false;
                    }
                });
        };
    }
]);
